module.exports = __webpack_public_path__ + "static/img/address.87c2c364.png";